import React from 'react';
import { RCIcon } from '../RCIcon';

interface IProps {
  svgComponent: (props: React.SVGProps<SVGElement>) => React.ReactSVGElement; // a specific svg imported from commons/design-system/icons
  children: React.ReactNode;
  placement?: 'right' | 'left',
  /* accessible title attribute; required for non-decorative icons, should be left blank if the icon is purely decorative and a screen reader
  can get the context from other elements */
  title?: string;
}

function IconWithWrapper({ placement, svgComponent, title }) {
  return (
    <span className={placement === 'left' ? 'mr-space' : 'ml-space'}>
      <RCIcon svgComponent={svgComponent} title={title} inline />
    </span>
  );
}

export function RCTextWithIcon({ svgComponent, children, title, placement = 'right' }: IProps) {
  return (
    <>
      {(placement === 'left') && <IconWithWrapper title={title} placement={placement} svgComponent={svgComponent} />}
      {children}
      {(placement === 'right') && <IconWithWrapper title={title} placement={placement} svgComponent={svgComponent} />}
    </>
  );
}
